export const speakerLogos = [
    {
        "id": 2502,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Daria_Abbaei_2022_01_27_16_54_17.png",
        "website": "https://www.naplestechnologyventures.com/"
    },
    {
        "id": 2704,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Adham_Abdelfattah_2022_01_27_16_52_33.png",
        "website": "http://interplay.vc"
    },
    {
        "id": 2583,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Paul_Allen_2022_01_27_16_57_55.png",
        "website": "http://www.tribeofangels.com"
    },
    {
        "id": 2562,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Suleiman_Arabiat_2022_01_27_16_54_27.png",
        "website": "https://www.elevator-ventures.com/"
    },
    {
        "id": 2499,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Nick_Arnold_2022_01_27_16_57_23.jpeg",
        "website": "http://hgventures.com"
    },
    {
        "id": 2657,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jacob_Banks_2022_01_27_16_52_58.jpeg",
        "website": "http://www.forwardleapcapital.com"
    },
    {
        "id": 2478,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Maurice_Beckand Verwee_2022_01_27_16_54_44.png",
        "website": "http://www.curiosityvc.com"
    },
    {
        "id": 2582,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Fatimah_Bello_2022_01_27_16_52_36.jpeg",
        "website": "http://www.climateimpactcapital.com"
    },
    {
        "id": 2705,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ivneet_Bhullar_2022_01_27_16_56_17.png",
        "website": "https://www.fusionfund.com/"
    },
    {
        "id": 2666,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jason_Blumberg_2022_01_27_16_55_00.png",
        "website": "http://www.energyfoundry.com"
    },
    {
        "id": 2569,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Andrew_Boyd_2022_01_27_16_56_48.jpeg",
        "website": "https://sandboxindustries.com/"
    },
    {
        "id": 2614,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Mark_Brooks_2022_01_27_16_57_20.png",
        "website": "https://www.syngentagroupventures.com/"
    },
    {
        "id": 2512,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jackson_Bubala_2022_01_27_16_56_37.jpeg",
        "website": "https://motivate.vc"
    },
    {
        "id": 2565,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Dan_Burstein_2022_01_27_18_26_52.png",
        "website": "http://www.mtvlp.com"
    },
    {
        "id": 2600,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Megan_Cain_2022_01_27_16_52_47.png",
        "website": "https://westlygroup.com/"
    },
    {
        "id": 2555,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ray_Chan_2022_01_27_16_57_29.png",
        "website": "http://k5ventures.com"
    },
    {
        "id": 2612,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Tiffany_Chen_2022_01_27_16_57_41.png",
        "website": "https://higbio.com/"
    },
    {
        "id": 2549,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Stephanie_Cherrin_2022_01_27_16_55_48.png",
        "website": "http://porsche.ventures"
    },
    {
        "id": 2589,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Michael_Cohen_2022_01_27_16_58_14.jpeg",
        "website": "http://www.saicvc.com"
    },
    {
        "id": 2607,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Bruce_Cohen_2022_01_27_16_55_51.png",
        "website": "http://www.xeraya.com"
    },
    {
        "id": 2662,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Mark_Crawford_2022_01_27_16_53_26.png",
        "website": "https://www.stanleyventures.com/"
    },
    {
        "id": 2525,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jenieri_Cyrus_2022_01_27_16_57_47.png",
        "website": "https://www.urbaninnovationfund.com/"
    },
    {
        "id": 2712,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Danielle_D'Agostaro_2022_01_27_18_44_43.png",
        "website": "https://www.wvvcapital.com/"
    },
    {
        "id": 2526,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jessica_Davis_2022_01_27_16_55_03.png",
        "website": "https://www.dynamk.vc/"
    },
    {
        "id": 2540,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Vivian_de Ruijter_2022_01_27_16_53_03.png",
        "website": "https://ventures.intuitive.com/"
    },
    {
        "id": 2638,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Maria_De Santis_2022_01_27_16_55_56.png",
        "website": "https://www.musecapital.vc/"
    },
    {
        "id": 2537,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alex_Delbridge_2022_01_27_16_54_47.jpeg",
        "website": "http://omegafunds.com"
    },
    {
        "id": 2669,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_James_Detweiler_2022_01_27_16_53_01.png",
        "website": "https://www.zettavp.com/"
    },
    {
        "id": 2564,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Michael_Donnelly_2022_01_27_16_57_31.png",
        "website": "http://www.ibexinvestors.com"
    },
    {
        "id": 2479,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Tracy_Dooley_2022_01_27_16_57_35.png",
        "website": "http://www.avestria.vc"
    },
    {
        "id": 2541,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Thomas_Englis_2022_01_27_16_56_45.jpeg",
        "website": "https://www.clearvisionventures.com/"
    },
    {
        "id": 2567,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Sergio_Escobar_2022_01_27_16_53_46.png",
        "website": "https://bcfventures.vc/"
    },
    {
        "id": 2644,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Chenoa_Farnsworth_2022_01_27_16_54_07.jpeg",
        "website": "http://www.bluestartups.com"
    },
    {
        "id": 2480,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Raphael_Fässler_2022_01_27_16_54_58.png",
        "website": "https://venture.post.ch/en#venture-capital"
    },
    {
        "id": 2584,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Tarik_Galijasevic_2022_01_27_16_52_31.png",
        "website": "https://www.allstate.com/strategic-ventures/main.htm"
    },
    {
        "id": 2613,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Lana_Ghanem_2022_01_27_16_54_04.png",
        "website": "http://www.hikmaventures.com"
    },
    {
        "id": 2503,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Paul_Gianneschi_2022_01_27_16_55_23.jpeg",
        "website": "http://www.hatchmedical.com"
    },
    {
        "id": 2476,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Andre_Glasberg_2022_01_27_16_52_20.jpeg",
        "website": "http://bandwidthcapital.com/"
    },
    {
        "id": 2573,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Vissaagan_Gopalakrishnan_2022_01_27_16_53_36.jpeg",
        "website": "http://www.agentcapital.com"
    },
    {
        "id": 2487,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_David_Gordon_2022_01_27_16_57_38.png",
        "website": "http://www.longliv-ventures.com"
    },
    {
        "id": 2645,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Melissa C._Guzy_2022_01_27_16_53_43.jpeg",
        "website": "http://www.arborventures.com"
    },
    {
        "id": 2656,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Matan_Hazanov_2022_01_27_16_53_06.png",
        "website": "http://verstraventures.com"
    },
    {
        "id": 2626,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Patrick_Hsu_2022_01_27_16_53_11.jpeg",
        "website": "http://aifund.ai"
    },
    {
        "id": 2482,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Denis_Kalyshkin_2022_01_27_16_57_17.jpeg",
        "website": "http://i2bf.com"
    },
    {
        "id": 2481,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jotthe_Kannappan_2022_01_27_16_53_48.png",
        "website": "https://ventures.intuitive.com/"
    },
    {
        "id": 2594,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_James_Kibbie_2022_01_27_16_56_09.jpeg",
        "website": "http://www.drwvc.com"
    },
    {
        "id": 2643,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Mary_King_2022_01_27_16_52_22.png",
        "website": "https://www.alignedclimatecapital.com/"
    },
    {
        "id": 2579,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Liam_Krut_2022_01_27_16_56_02.jpeg",
        "website": "http://reinforcedventures.com"
    },
    {
        "id": 2636,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Louise_Kushner_2022_01_27_16_53_18.png",
        "website": "http://plumalley.co"
    },
    {
        "id": 2513,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ricky_Lai_2022_01_27_16_55_17.png",
        "website": "http://portagevc.com"
    },
    {
        "id": 2640,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_David_Li_2022_01_27_16_57_27.jpeg",
        "website": "https://www.avantaventures.com/"
    },
    {
        "id": 2667,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Judy_Li_2022_01_27_16_54_25.png",
        "website": "http://www.energyfoundry.com"
    },
    {
        "id": 2495,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ephraim_Lindenbaum_2022_01_27_16_55_33.png",
        "website": "http://www.advanceventures.com"
    },
    {
        "id": 2556,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Darwin_Ling_2022_01_27_16_56_14.png",
        "website": "http://www.goodai.capital"
    },
    {
        "id": 2523,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jim_Lockheed_2022_01_27_16_53_31.png",
        "website": "http://www.jetblueventures.com"
    },
    {
        "id": 2530,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Kevin_Lu_2022_01_27_16_55_36.png",
        "website": "http://www.ngpcap.com"
    },
    {
        "id": 2635,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Vincent_Lui_2022_01_27_16_55_26.png",
        "website": "https://www.skta.com"
    },
    {
        "id": 2524,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ruchit_Majmudar_2022_01_27_16_56_05.jpeg",
        "website": "https://www.jetblueventures.com/"
    },
    {
        "id": 2631,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_David_Mandel_2022_01_27_16_56_40.jpeg",
        "website": "https://emerging.vc"
    },
    {
        "id": 2629,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jennifer_Mandelbaum_2022_01_27_16_54_22.png",
        "website": "http://halogenvc.com"
    },
    {
        "id": 2586,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Laura_Marchiori_2022_01_27_16_52_49.png",
        "website": "https://indicatorcapital.com/"
    },
    {
        "id": 2542,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Hugh G._Martin_2022_01_27_16_54_12.png",
        "website": "https://www.atentocapital.com/"
    },
    {
        "id": 2527,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Laleh_Masnavi_2022_01_27_16_54_37.png",
        "website": "http://www.candouventures.com"
    },
    {
        "id": 2522,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Hannah_McQuaid_2022_01_27_16_58_00.jpeg",
        "website": "http://pruvencap.com"
    },
    {
        "id": 2505,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Aashna_Mehra_2022_01_27_16_54_52.png",
        "website": "https://newenergycapital.com/"
    },
    {
        "id": 2617,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Tahl_Milburn_2022_01_27_16_55_12.png",
        "website": "http://newworldangels.com"
    },
    {
        "id": 2610,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Daniel_Miller_2022_01_27_18_39_48.jpeg",
        "website": "http://RodaGroup.com"
    },
    {
        "id": 2668,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Kike_Miralles_2022_01_27_16_54_35.png",
        "website": "http://starlight.vc"
    },
    {
        "id": 2575,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Shohei_Nagatsuka_2022_01_27_16_55_54.png",
        "website": "https://www.mcrockcapital.com/"
    },
    {
        "id": 2535,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Mitchell_Ng_2022_01_27_16_52_24.png",
        "website": "http://thessaluscapital.com/"
    },
    {
        "id": 2670,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Chidi_Nwankpa_2022_01_27_18_36_09.png",
        "website": "https://www.gorerangecapital.com/"
    },
    {
        "id": 2715,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_Brooke_O'Leary_2022_02_23_16_12_50.png",
        "website": "https://ftvcapital.com/"
    },
    {
        "id": 2581,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alex_Owen_2022_01_27_16_54_30.jpeg",
        "website": "https://fuelventurecapital.com/"
    },
    {
        "id": 2621,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Vic_Pascucci III_2022_01_27_16_55_46.png",
        "website": "https://www.energycapitalventures.com"
    },
    {
        "id": 2619,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alan_Pereira_2022_01_27_16_53_54.png",
        "website": "http://www.seldorcapital.com"
    },
    {
        "id": 2518,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Aston_Pierce_2022_01_27_16_56_50.png",
        "website": "https://www.edisonpartners.com/"
    },
    {
        "id": 2622,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Shelly_Rao_2022_01_27_16_54_01.jpeg",
        "website": "https://www.juniper.net/us/en/company/ventures.html"
    },
    {
        "id": 2671,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Drake_Rehfeld_2022_01_27_18_39_10.jpeg",
        "website": "http://dayoneventures.com"
    },
    {
        "id": 2517,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Katherine_Relle_2022_01_27_16_54_49.svg",
        "website": "http://accelmed.com"
    },
    {
        "id": 2550,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Catherine_Rhee_2022_01_27_16_54_20.jpeg",
        "website": "http://www.legendary.vc"
    },
    {
        "id": 2504,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jordan_Rohrlich_2022_01_27_16_58_03.png",
        "website": "http://activatecp.com"
    },
    {
        "id": 2561,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alexander_Rozenfeld_2022_01_27_16_58_07.jpeg",
        "website": "https://climateimpactcapital.com/"
    },
    {
        "id": 2544,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Maximilian_Schausberger_2022_01_27_16_52_39.png",
        "website": "https://www.elevator-ventures.com"
    },
    {
        "id": 2585,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Reese_Schroeder_2022_01_27_16_55_28.png",
        "website": "https://www.allstate.com/strategic-ventures/main.htm"
    },
    {
        "id": 2599,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Brian_Schuman_2022_01_27_16_56_52.svg",
        "website": "http://www.pepsico.com"
    },
    {
        "id": 2616,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ramsay_Siegal_2022_01_27_16_58_17.png",
        "website": "http://www.earthshot.vc"
    },
    {
        "id": 2514,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Blair_Simpson_2022_01_27_16_55_20.jpeg",
        "website": "https://frontiervc.com/"
    },
    {
        "id": 2496,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Siddharth_Singhai_2022_01_27_16_54_09.png",
        "website": "http://ironholdcapital.com"
    },
    {
        "id": 2511,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Shounok_Sinha_2022_01_27_16_53_56.png",
        "website": "http://technologyventures.constellation.com/"
    },
    {
        "id": 2608,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jean_Sini_2022_01_27_16_55_38.png",
        "website": "http://partechpartners.com"
    },
    {
        "id": 2521,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Brett_Sleyster_2022_01_27_16_53_21.jpeg",
        "website": "https://www.pruvencap.com/"
    },
    {
        "id": 2672,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Eric_Snyder_2022_01_27_16_56_55.jpeg",
        "website": "https://www.novoholdings.dk/investments/ventures/"
    },
    {
        "id": 2615,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Simon_Sokol_2022_01_27_16_52_41.png",
        "website": "http://relayventures.com"
    },
    {
        "id": 2574,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Catello_Somma_2022_01_27_18_33_51.gif",
        "website": "https://www.tvm-lifescience.com/"
    },
    {
        "id": 2498,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Peter_Sopher_2022_01_27_16_53_16.png",
        "website": "http://www.cleanenergyventures.com"
    },
    {
        "id": 2632,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Aya_Spencer_2022_01_27_16_53_59.png",
        "website": "http://www.kaporcapital.com"
    },
    {
        "id": 2646,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alexander_Starchenko_2022_01_27_16_52_56.png",
        "website": "https://firstimagine.com/"
    },
    {
        "id": 2519,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_John_Stine_2022_01_27_16_57_52.jpeg",
        "website": "https://www.3igventures.com/"
    },
    {
        "id": 2477,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ning_Sung_2022_01_27_16_56_35.png",
        "website": "http://www.sandhillangels.com"
    },
    {
        "id": 2539,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Simran_Suri_2022_01_27_16_55_43.png",
        "website": "https://www.equal.vc/"
    },
    {
        "id": 2543,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Angela_Tay_2022_01_27_16_56_22.png",
        "website": "https://agfunder.com/"
    },
    {
        "id": 2605,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Gaurav_Tewari_2022_01_27_16_56_33.png",
        "website": "https://www.omegavp.com"
    },
    {
        "id": 2560,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Lucas_Timberlake_2022_01_27_16_55_06.png",
        "website": "http://www.fintechv.com"
    },
    {
        "id": 2536,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Dora_Trachana_2022_01_27_16_52_28.jpeg",
        "website": "http://uni.fund"
    },
    {
        "id": 2572,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Joe_Tsai_2022_01_27_16_57_49.png",
        "website": "http://mucker.com/"
    },
    {
        "id": 2625,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Vera_Uboytseva_2022_01_27_16_52_44.png",
        "website": "https://bplaunchpad.com/"
    },
    {
        "id": 2515,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Jose Antonio_Urrutia Rivas_2022_01_27_16_53_39.jpeg",
        "website": "http://www.otv.vc"
    },
    {
        "id": 2654,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Sarah_Visser_2022_01_27_16_56_20.png",
        "website": "https://www.framework.vc/"
    },
    {
        "id": 2620,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Neeraj_Vohra_2022_01_27_16_56_42.png",
        "website": "http://www.naplestechnologyventures.com"
    },
    {
        "id": 2520,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Andrew_Wegrzyn_2022_01_27_16_54_32.jpeg",
        "website": "http://sixthirty.co"
    },
    {
        "id": 2532,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Brian_Wei_2022_01_27_16_54_55.png",
        "website": "https://www.bmwiventures.com/"
    },
    {
        "id": 2566,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Stephanie_Wood_2022_01_27_16_55_15.jpeg",
        "website": "http://www.alatepartners.com"
    },
    {
        "id": 2557,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Irit_Yaniv_2022_01_27_16_56_30.png",
        "website": "http://www.almedaventures.com"
    },
    {
        "id": 2587,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Ketan_Yerneni_2022_01_27_16_52_53.jpeg",
        "website": "https://www.kdtvc.com"
    },
    {
        "id": 2652,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Alicia_Zheng_2022_01_27_16_57_58.jpeg",
        "website": "https://plumalley.co"
    },
    {
        "id": 2659,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Chen_Zhou_2022_01_27_16_55_41.png",
        "website": "https://samsungcatalyst.com/"
    },
    {
        "id": 2563,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Tony_Zhu_2022_01_27_16_53_34.jpeg",
        "website": "http://evergreeninno.org"
    },
    {
        "id": 2576,
        "logo_url": "https://youngstartup.io/storage/uploads/speaker_headshots/logo_url_Anthony_Zlaket_2022_01_27_16_54_40.png",
        "website": "https://unitypointhealthventures.org/"
    }
]